import React from 'react'

interface PintGlassIconProps {
  size?: number
  colour?: string
}

const DEFAULT_SIZE = 18

const Svg = ({ size = DEFAULT_SIZE, children }: { size: number; children: React.ReactNode }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
)

export const PintGlassEmptyIcon: React.FC<PintGlassIconProps> = ({ size = DEFAULT_SIZE, colour = 'currentColor' }) => (
  <Svg size={size}>
    <path
      d="M7 3h10l-1.5 18.2c-.05.45-.43.8-.88.8H9.38c-.45 0-.83-.35-.88-.8L7 3z"
      stroke={colour}
      strokeWidth="2.2"
      strokeLinejoin="round"
    />
    <path d="M8.2 8.5h7.6" stroke={colour} strokeWidth="1.8" strokeLinecap="round" opacity="0.55" />
  </Svg>
)

export const PintGlassHalfIcon: React.FC<PintGlassIconProps> = ({ size = DEFAULT_SIZE, colour = 'currentColor' }) => (
  <Svg size={size}>
    <path
      d="M7 3h10l-1.5 18.2c-.05.45-.43.8-.88.8H9.38c-.45 0-.83-.35-.88-.8L7 3z"
      stroke={colour}
      strokeWidth="2.2"
      strokeLinejoin="round"
    />
    <path
      d="M8.4 13.2h7.2l-.9 8.6H9.3l-.9-8.6z"
      fill={colour}
      opacity="0.9"
    />
    <path d="M8.35 13.2h7.3" stroke={colour} strokeWidth="1.8" strokeLinecap="round" opacity="0.85" />
  </Svg>
)

export const PintGlassFullIcon: React.FC<PintGlassIconProps> = ({ size = DEFAULT_SIZE, colour = 'currentColor' }) => (
  <Svg size={size}>
    <path
      d="M7 3h10l-1.5 18.2c-.05.45-.43.8-.88.8H9.38c-.45 0-.83-.35-.88-.8L7 3z"
      stroke={colour}
      strokeWidth="2.2"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 6.2h7.5l-1.2 15.6H9.45L8.25 6.2z"
      fill={colour}
      opacity="0.9"
    />
  </Svg>
)

export const TastingListIcon: React.FC<PintGlassIconProps> = ({ size = DEFAULT_SIZE, colour = 'currentColor' }) => (
  <Svg size={size}>
    <path
      d="M8 4.5h8c.55 0 1 .45 1 1V20l-5-3-5 3V5.5c0-.55.45-1 1-1z"
      stroke={colour}
      strokeWidth="2.2"
      strokeLinejoin="round"
    />
  </Svg>
)
